<script>
import BOForm from '../../baseComponents/boForm'
import { themes, usableDates, regexpDates } from '../../variables'

export default {
	extends: BOForm,
	data() {
		return {
			items: [
				{ label: 'Nom', value: 'key', type: 'text', required: true },
				{
					label: 'Theme',
					value: 'theme',
					type: 'select',
					values: themes,
					required: true,
				},
				{
					label: "Configuration d'envoi",
					type: 'sub-doc',
					value: 'schedule',
					required: true,
					items: [
						{
							label: 'Délai (mois)',
							value: 'monthDelay',
							type: 'number',
							rules: [(v) => v >= 0 || '>= à 0'],
						},
						{
							label: 'Délai (semaines)',
							value: 'weekDelay',
							type: 'number',
							rules: [(v) => v >= 0 || '>= à 0'],
						},
						{
							label: 'Délai (jours)',
							value: 'dayDelay',
							type: 'number',
							rules: [(v) => v >= 0 || '>= à 0'],
						},
						{
							label: 'Heure',
							value: 'hour',
							type: 'select',
							itemText: 'text',
							itemValue: 'value',
							values: [
								'0',
								'1',
								'2',
								'3',
								'4',
								'5',
								'6',
								'7',
								'8',
								'9',
								'10',
								'11',
								'12',
								'13',
								'14',
								'15',
								'16',
								'17',
								'18',
								'19',
								'20',
								'21',
								'22',
								'23',
							].map((text) => ({ text, value: Number(text) })),
							rules: [(v) => v >= 0 || 'champs requis'],
						},
						{
							label: 'Minutes',
							value: 'minutes',
							type: 'select',
							itemText: 'text',
							itemValue: 'value',
							values: ['0', '15', '30', '45'].map((text) => ({ text, value: Number(text) })),
							rules: [(v) => v >= 0 || 'champs requis'],
						},
						{
							label: 'Filtre',
							value: 'filters',
							type: 'text',
							rules: [
								(v) =>
									!v ||
									v
										.trim()
										.split(';')
										.filter((filter) => filter !== '')
										.reduce(
											(valid, filter) =>
												valid &&
												filter
													.trim()
													.split(/!=|=/)
													.filter((filter) => filter !== '').length === 2,
											true,
										) ||
									"Format du filtre = 'key=value;key2!=value'",
							],
						},
					],
				},
				{
					label: 'SMS',
					value: 'sms',
					// rules: [(v) => (!!v && v.indexOf('{link}') !== -1) || "{link} n'est pas présent"],
					type: 'text-area',
					hint: `Ecrire {link} pour inclure le lien du subbot. \n
                {nomAnimal} {espece} ${usableDates} {prenom} {nom} {mail} seront remplacé par les données de l'utilisateur.
			          Pour faire une condition : {if 'valeur'}{else}{edif} ou {if 'valeur'}{endif} ou valeur peut être tu,vous,M, F, chien, chienne, chat, chatte, animalM, animalF.
			          Exemple : {if tu}tu peux{else}vous pouvez{endif}`,
				},
				{
					label: 'Message tutoiement masculin, chien :',
					value: 'messageMT',
					type: 'text-area',
					disabled: true,
				},
				{
					label: 'Message vouvoiement féminin, chienne :',
					value: 'messageFV',
					type: 'text-area',
					disabled: true,
				},
				{
					label: 'Message tutoiement masculin, chat :',
					value: 'messageMT2',
					type: 'text-area',
					disabled: true,
				},
				{
					label: 'Message vouvoiement féminin, chatte :',
					value: 'messageFV2',
					type: 'text-area',
					disabled: true,
				},
			],
		}
	},
	computed: {
		formatedDate() {
			return new Date().toLocaleString('fr').split(/\s|,/)[0]
		},
	},
	watch: {
		'model.sms': function(newVal) {
			const message = this.model.sms ? this.model.sms : ''
			let res = message
				.replace(/{link}/g, 'https://exemplexxxx.com')
				.replace(/{espece}/g, 'chien')
				.replace(/{prenom}/g, 'Pierre')
				.replace(/{nomAnimal}/g, 'Pixel')
				.replace(regexpDates, this.formatedDate)
				.replace(/{nom}/g, 'dupont')
				.replace(/{mail}/g, 'pierre@gmail.com')
			let messageMT = this.formatMessage(res, { tu_vous: 'tu', genre: 'M', genreAnimal: 'M', espece: 'chien' })
			res = message
				.replace(/{link}/g, 'https://exemplexxxx.com')
				.replace(/{espece}/g, 'chienne')
				.replace(/{prenom}/g, 'Marie-Dominique')
				.replace(/{nomAnimal}/g, 'Checky')
				.replace(regexpDates, this.formatedDate)
				.replace(/{nom}/g, 'dupond')
				.replace(/{mail}/g, 'marie.dominique@gmail.com')
			let messageFV = this.formatMessage(res, { tu_vous: 'vous', genre: 'F', genreAnimal: 'F', espece: 'chienne' })
			res = message
				.replace(/{link}/g, 'https://exemplexxxx.com')
				.replace(/{espece}/g, 'chat')
				.replace(/{prenom}/g, 'Pierre')
				.replace(/{nomAnimal}/g, 'Pixel')
				.replace(regexpDates, this.formatedDate)
				.replace(/{nom}/g, 'dupont')
				.replace(/{mail}/g, 'pierre@gmail.com')
			let messageMT2 = this.formatMessage(res, { tu_vous: 'tu', genre: 'M', genreAnimal: 'M', espece: 'chat' })
			res = message
				.replace(/{link}/g, 'https://exemplexxxx.com')
				.replace(/{espece}/g, 'chatte')
				.replace(/{prenom}/g, 'Marie-Dominique')
				.replace(/{nomAnimal}/g, 'Checky')
				.replace(regexpDates, this.formatedDate)
				.replace(/{nom}/g, 'dupond')
				.replace(/{mail}/g, 'marie.dominique@gmail.com')
			let messageFV2 = this.formatMessage(res, { tu_vous: 'vous', genre: 'F', genreAnimal: 'F', espece: 'chatte' })
			this.model = {
				...this.model,
				messageMT,
				messageFV,
				messageMT2,
				messageFV2,
			}
			;['messageMT', 'messageFV', 'messageMT2', 'messageFV2'].forEach((keyValue) => {
				const item = this.items.find((item) => item.value === keyValue)
				if (item) {
					item.label = item.label.split(':')[0] + `: ${this.model[keyValue].lenght} / 145`
				}
			})
		},
	},
	methods: {
		formatCondition(conditionString, params) {
			let ifCondition = conditionString.substring(3, conditionString.indexOf('}'))

			ifCondition = ifCondition.replace(/ /g, '')
			const value =
				ifCondition === 'tu' || ifCondition === 'vous'
					? params.tu_vous
					: ifCondition === 'M' || ifCondition === 'F'
					? params.genre
					: ifCondition === 'animalM' || ifCondition === 'animalF'
					? `animal${params.genreAnimal}`
					: ifCondition === 'chien' || ifCondition === 'chienne' || ifCondition === 'chatte' || ifCondition === 'chat'
					? params.espece.toLowerCase()
					: null

			if (ifCondition === value) {
				let elseIndex = conditionString.indexOf('{else}')
				elseIndex = elseIndex === -1 ? conditionString.length : elseIndex
				conditionString = conditionString.substring(conditionString.indexOf('}') + 1, elseIndex)
			} else {
				let elseIndex = conditionString.indexOf('{else}')
				if (elseIndex == -1) {
					conditionString = ''
				} else {
					conditionString = conditionString.substring(elseIndex + 6, conditionString.length)
				}
			}
			return conditionString
		},
		formatMessage(message, params) {
			let nextIf, endIf
			let currentIf = message.indexOf('{if')
			let error = false

			while (currentIf !== -1 && !error) {
				endIf = message.indexOf('{endif}', currentIf + 1)
				if (endIf === -1) {
					error = true
				} else {
					nextIf = message.indexOf('{if', currentIf + 1)
					while (nextIf !== -1 && nextIf < endIf) {
						currentIf = nextIf
						nextIf = message.indexOf('{if', currentIf + 1)
					}

					let conditionString = message.substring(currentIf, endIf)
					message =
						message.substring(0, currentIf) +
						this.formatCondition(conditionString, params) +
						message.substring(endIf + 7, message.length)
				}
				currentIf = message.indexOf('{if')
			}
			return message
		},
		async post() {
			const { messageMT, messageFV, messageMT2, messageFV2, ...send } = this.model
			await this.axios.post('default-parameters', send)
		},
		async put() {
			const { messageMT, messageFV, messageMT2, messageFV2, ...send } = this.model
			await this.axios.put('default-parameters/' + this.model._id, send)
		},
	},
}
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/components/defaultParameters/defaultParameters.form.vue